import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Palette } from "../AppConfig";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import { StyledEngineProvider } from "@mui/material/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

const useStyles = makeStyles({
    root: {
        width: "170px",
        display: "flex",
        borderRadius: "4px",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "8px",
        margin: "5px",
    },
    thumbnail: {
        height: "100px",
        "& img": {
            width: "100%",
            filter: "grayscale(100%)",
        },
    },
    thumbnailSelected: {
        "& img": {
            filter: "grayscale(0%)",
        },
    },
    label: {
        font: "16px 'Univers45', sans-serif",
        color: Palette.Control.DarkGrey,
        padding: "7px",
    },
    labelSelected: {
        fontWeight: 600,
    },
    selectedItem: {
        backgroundColor: Palette.Control.PaleBlueTrans,
        margin: "4px",
    },
    subItem: {
        font: "200 14px 'canada-type-gibson', sans-serif",
        paddingLeft: "5px",
        paddingRight: "5px",
    },
    selectedSubItem: {
        backgroundColor: Palette.Control.PaleBlueTrans,
    },
    disabled: {
        opacity: 0.5,
        pointerEvents: "none",
    },
    linearProgress: {
        width: "100%",
        height: "5px",
    },
    hide: {
        visibility: "hidden",
        opacity: 0,
        transition: "opacity 0.5s",
        flex: "initial !important",
    },
    show: {
        visibility: "visible",
        opacity: 1,
        transition: "opacity 0.5s",
        flex: "initial !important",
    },
    message: {
        width: "100%",
        height: "30px",
        textAlign: "center",
        font: "13px 'canada-type-gibson', sans-serif",
    },
});

export default function TemplateCard(props) {
    const classes = useStyles(window.FIEDLERS);
    const [activeItem, setActiveItem] = useState(null);

    useEffect(() => {
        if (!props.selected && props.onClickSub) {
            setActiveItem(null);
            props.onClickSub(null);
        }
    }, [props.selected, props.onClickSub]);

    return (
        <div
            className={`${classes.root} ${props.selected ? classes.selectedItem : ""} `}
            onClick={() => (!props.disabled && props.onClick ? props.onClick(props.label) : null)}
        >
            <div
                className={`${classes.thumbnail} ${props.selected ? classes.thumbnailSelected : ""} ${
                    props.disabled ? classes.disabled : ""
                }`}
            >
                {props.src && <img src={props.src} />}
            </div>

            <div className={`${classes.message} ${props.disabledMessage ? classes.show : classes.hide} error`}>
                <ErrorOutlineIcon
                    style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "8px",
                    }}
                />
                {props.disabledMessage}
            </div>

            {props.label && (
                <div
                    className={`${classes.label} ${props.selected ? classes.labelSelected : ""} ${
                        props.disabled ? classes.disabled : ""
                    }`}
                >
                    {props.label}
                </div>
            )}

            {props.loading && <LinearProgress className={`${classes.linearProgress}`} />}
            {props.items && (
                <StyledEngineProvider injectFirst>
                    <List
                        className={`${props.disabled ? classes.disabled : ""}`}
                        disablePadding
                        sx={{
                            width: "100%",
                            bgcolor: "background.paper",
                            borderBottomLeftRadius: "4px",
                            borderBottomRightRadius: "4px",
                        }}
                    >
                        <Collapse in={props.selected} timeout="auto" unmountOnExit>
                            <List component="div">
                                {props.items &&
                                    props.items.map((item, index) => (
                                        <ListItemButton
                                            key={index}
                                            sx={{ width: "100%" }}
                                            className={
                                                activeItem === index && props.selected ? classes.selectedSubItem : ""
                                            }
                                            onClick={() => {
                                                if (props.selected && !props.disabled) {
                                                    setActiveItem(index);
                                                    props.onClickSub(item);
                                                }
                                            }}
                                        >
                                            <ListItemText
                                                primaryTypographyProps={{ className: classes.subItem }}
                                                primary={item}
                                            />
                                        </ListItemButton>
                                    ))}
                            </List>
                        </Collapse>
                    </List>
                </StyledEngineProvider>
            )}
        </div>
    );
}